import { render, staticRenderFns } from "./bidPriceDetail.vue?vue&type=template&id=0ba63985&scoped=true&"
import script from "./bidPriceDetail.vue?vue&type=script&lang=js&"
export * from "./bidPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./bidPriceDetail.vue?vue&type=style&index=0&id=0ba63985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba63985",
  null
  
)

export default component.exports